import { Card, Col, Container, Row, Spinner } from "react-bootstrap";
import BitacoraFiltros, { tiposConsumoMultiselect } from "./componentes/filters";
import { useCallback, useEffect, useState } from "react";
//import MasterTableBitacora from "./componentes/bitacora-lista/TablaBitacoras";
import { ConsumoService } from "../../../services/apiService";
import { toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
import { decryptData } from "../../../helpers/utils";
import CardSMS from "./componentes/cards-consumo/card-sms";
import CardEmail from "./componentes/cards-consumo/card-email";
import CardWhatsapp from "./componentes/cards-consumo/card-whatsapp";
import CardVoz from "./componentes/cards-consumo/card-voz";
import reporteConsumoStore, { datosDisponibles } from "../../../lib/store/reporte_consumo_store";
import dayjs from "dayjs";
import FiltrosConsumos from "./componentes/filtros-consumo/FiltrosConsumos";
import ConsumosTotales from "./componentes/consumos-totales";
import CardConsumos from "./componentes/cards-consumo/card-consumo";
import { LoadingEmptyState, NoDataEmptyState, NoSelectionEmptyState, WelcomeEmptyState } from "../../../components/common/EmptyState";
import StandardProgressBar from "../../../components/common/ProgressBar/StandardProgressBar";
import PrintReportModule from "../../../components/print/PrintReportModule";

export const formatPhoneNumber = (phone) => {
    if (!phone) return '';
    const cleaned = phone.replace(/[^\d+]/g, '');
    const match = cleaned.match(/^(\+?52)(1?)(\d{10})$/);
    if (match) {
        const prefix = match[1];
        const isMobile = match[2];
        const number = match[3];
        const formatted = `(${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(6)}`;
        return `${prefix} ${isMobile} ${formatted}`.trim();
    }
    const localMatch = cleaned.match(/^(\d{10})$/);
    if (localMatch) {
        const number = localMatch[1];
        return `(${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(6)}`;
    }
    return phone;
}

const ConsumoReport = () => {
    const {
        cargaActiva, editarCargaActiva, fecha, selTipoConsumo, selectedTipoConsumo,
        usuarioOmisiones, editarUsuarioOmisiones, editarSMS, editarEmail, editarWhatsapp, editarVoz,
        sms, email, whatsapp, voz,
    } = reporteConsumoStore();

    const [isLoadingPackages, setIsLoadingPackages] = useState(false);

    const [debugMetrics, setDebugMetrics] = useState({
        searchStartTime: null,
        searchEndTime: null,

        connections: {
            'ListTable': {
                name: 'Consumos (GPS)',
                startTime: null,
                endTime: null,
                totalRecordsExpected: 0,
                totalRecordsReceived: 0,
                totalApiCalls: 0,
                completedApiCalls: 0,
                failedApiCalls: 0,
                recoveredApiCalls: 0,
                apiCallsHistory: [],
                downloadProgress: 0,
                status: 'pending'
            }
        },

        globalTotalRecordsExpected: 0,
        globalTotalRecordsReceived: 0,
        globalDownloadProgress: 0,
        activeConnections: 0,

        componentTimes: {
            table: { start: null, end: null },
            vehicles: { start: null, end: null },
            alerts: { start: null, end: null },
            map: { start: null, end: null },
            frequency: { start: null, end: null }
        }
    });

    const updateComponentProgress = useCallback((component, progress, isComplete = false) => {
        setLoadingComponents(prevState => {
            const newState = { ...prevState };

            if (newState[component]) {
                newState[component] = {
                    ...newState[component],
                    loading: !isComplete,
                    progress: isComplete ? 100 : Math.max(0, Math.min(100, progress)),
                    complete: isComplete
                };
            }

            return newState;
        });

        // ✅ Actualizar métricas directamente sin dependencia circular
        setDebugMetrics(prev => ({
            ...prev,
            componentTimes: {
                ...prev.componentTimes,
                [component]: {
                    start: !isComplete ? Date.now() : (prev.componentTimes[component]?.start || Date.now()),
                    end: isComplete ? Date.now() : null
                }
            }
        }));
    }, []);

    const updateDebugMetrics = useCallback((updates) => {
        setDebugMetrics(prev => {
            if (!prev || !prev.connections) {
                console.warn('⚠️ debugMetrics no está inicializado correctamente');
                return prev || {
                    connections: {},
                    globalTotalRecordsExpected: 0,
                    globalTotalRecordsReceived: 0,
                    globalDownloadProgress: 0,
                    activeConnections: 0,
                    componentTimes: {}
                };
            }
            const newState = { ...prev };

            if (updates.connectionId && newState.connections[updates.connectionId]) {
                const connection = newState.connections[updates.connectionId];

                if (!connection.apiCallsHistory) {
                    connection.apiCallsHistory = [];
                }

                // Actualizar datos específicos de la conexión
                Object.keys(updates).forEach(key => {
                    if (key !== 'connectionId') {
                        if (key === 'apiCallsHistory' && Array.isArray(updates[key])) {
                            const newCalls = updates[key].map(call => ({
                                ...call,
                                timestamp: call.timestamp || Date.now()
                            }));
                            connection[key] = [...(connection[key] || []), ...newCalls];

                            if (connection[key].length > 50) {
                                connection[key] = connection[key].slice(-50);
                            }
                        } else if (key !== 'apiCallsHistory') {
                            connection[key] = updates[key];
                        }
                    }
                });

                const activeConnections = Object.values(newState.connections).filter(conn =>
                    conn && (conn.status === 'downloading' || conn.status === 'completed')
                );

                newState.globalTotalRecordsExpected = activeConnections.reduce((sum, conn) =>
                    sum + (conn.totalRecordsExpected || 0), 0
                );

                newState.globalTotalRecordsReceived = activeConnections.reduce((sum, conn) =>
                    sum + (conn.totalRecordsReceived || 0), 0
                );

                newState.globalDownloadProgress = newState.globalTotalRecordsExpected > 0 ?
                    (newState.globalTotalRecordsReceived / newState.globalTotalRecordsExpected * 100) : 0;

                newState.activeConnections = activeConnections.length;

            } else if (updates.connectionId && !newState.connections[updates.connectionId]) {
                newState.connections[updates.connectionId] = {
                    name: updates.connectionId,
                    startTime: null,
                    endTime: null,
                    totalRecordsExpected: 0,
                    totalRecordsReceived: 0,
                    totalApiCalls: 0,
                    completedApiCalls: 0,
                    failedApiCalls: 0,
                    recoveredApiCalls: 0,
                    apiCallsHistory: [],
                    downloadProgress: 0,
                    status: 'pending'
                };

                Object.keys(updates).forEach(key => {
                    if (key !== 'connectionId') {
                        newState.connections[updates.connectionId][key] = updates[key];
                    }
                });

            } else {
                Object.keys(updates).forEach(key => {
                    if (key === 'componentTimes') {
                        if (!newState.componentTimes) {
                            newState.componentTimes = {};
                        }
                        newState.componentTimes = { ...newState.componentTimes, ...updates.componentTimes };
                    } else if (key !== 'connectionId') {
                        newState[key] = updates[key];
                    }
                });
            }

            return newState;
        });

        // ✅ SINCRONIZAR DESCARGA CON BARRA DE PROGRESO
        if (updates.connectionId && updates.downloadProgress !== undefined) {
            setTimeout(() => {
                const componentMapping = {
                    'ListTable': 'list'
                };

                const componentName = componentMapping[updates.connectionId];

                if (componentName) {
                    // ✅ Usar el progreso real de descarga para actualizar el componente
                    const isComplete = updates.downloadProgress >= 100;
                    const progressValue = Math.round(updates.downloadProgress || 0);

                    console.log(`🔄 [Sincronización] ${componentName}: ${progressValue}% (descarga ${isComplete ? 'completa' : 'en progreso'})`);

                    updateComponentProgress(componentName, progressValue, isComplete);

                    // ✅ Si la descarga está completa, también marcar como cargando = false
                    if (isComplete) {
                        setLoadingComponents(prevState => ({
                            ...prevState,
                            [componentName]: {
                                loading: false,
                                progress: 100,
                                complete: true
                            }
                        }));
                    }
                }
            }, 0);
        }
    }, [updateComponentProgress]);

    const [loadingComponents, setLoadingComponents] = useState({
        table: { loading: false, progress: 0, complete: false },
        vehicles: { loading: false, progress: 0, complete: false }
    });
    const calculateTotalProgress = useCallback(() => {
        const weights = {
            table: 0.4,      // ✅ Ajustar para que sume 100%
            vehicles: 0.3,   // ✅ Solo componentes que existen
            alerts: 0.3,     // ✅ Solo componentes que existen                
        };

        let totalProgress = 0;
        let totalWeight = 0;

        Object.entries(loadingComponents).forEach(([component, state]) => {
            if (state && (state.loading || state.complete)) {
                const progress = Number(state.progress);
                if (!isNaN(progress)) {
                    totalProgress += progress * weights[component];
                    totalWeight += weights[component];
                } else {
                    totalProgress += (state.complete ? 100 : 0) * weights[component];
                    totalWeight += weights[component];
                }
            }
        });

        if (totalWeight === 0) return 0;
        const result = totalProgress / totalWeight;

        return Math.min(Math.max(result, 0), 100);
    }, [loadingComponents]);

    const datosDisponibles = () => sms !== null || email !== null || whatsapp !== null && voz !== null;

    const handleGenerateReport = () => {
        editarUsuarioOmisiones(null);
        requestAuth();
    };

    const requestAuth = async () => {
        setDebugMetrics(prev => ({
            ...prev,
            searchStartTime: prev.searchStartTime || Date.now(),
            searchEndTime: null
        }));

        // ✅ MARCAR COMPONENTE COMO CARGANDO AL INICIAR DESCARGA
        setLoadingComponents(prevState => ({
            ...prevState,
            table: { loading: true, progress: 0, complete: false }
        }));

        //Iniciar progrso de carga 
        updateComponentProgress('table', 0, false);
        try {
            const decoded = jwtDecode(localStorage.getItem('token'));
            let postData = decryptData(localStorage.getItem('token_consumo'), `${decoded.uid_empresa}`);

            const responseAuth = await ConsumoService.getAuth(JSON.parse(postData));
            if (responseAuth && responseAuth.success) {
                localStorage.setItem("token_omisiones", responseAuth.data.token);
                updateComponentProgress('table', 10, false);
                editarUsuarioOmisiones(responseAuth.data.user);
            } else {
                toast.error(responseAuth?.message || "Error al generar reporte");
            }
        } catch (error) {
            editarCargaActiva(false);
            updateComponentProgress('table', 100, false);
            console.error("Error al cargar puntos cercanos:", error);
        }
    };

    useEffect(() => {
        if (usuarioOmisiones === null)
            return;
        if (isLoadingPackages)
            return;
        setIsLoadingPackages(true);
        console.log("Cargar consumo");
        const requestCompanyHistory = async (filtros) => {
            try {
                /* CARGA DE HISTORIAL DE COMPAÑIA */
                let getDataCompanyHistory = new URLSearchParams({
                    ...filtros,
                }).toString()
                const responseCompanyHistory = await ConsumoService.getCompanyHistory(usuarioOmisiones.uid_empresa, getDataCompanyHistory,);
                if (responseCompanyHistory && responseCompanyHistory.success) {
                    let companyHistory = responseCompanyHistory.data;

                    var tempSMS = null;
                    var tempEmail = null;
                    var tempWhatsapp = null;
                    var tempVoz = null;

                    companyHistory.forEach((item) => {
                        var temp = {
                            filtros: filtros,
                            idempresa: usuarioOmisiones.uid_empresa,
                            tipoNotificacion: item.packageInfo.tipo.toLowerCase(),
                            id: item._id,
                            cantidad: item.changes.current.cantidad,
                            disponibles: item.changes.current.disponibles,
                            utilizadas: item.changes.current.utilizadas,
                            costo_total: item.changes.current.utilizadas * item.changes.current.costo_unitario,
                            fecha: item.changes.current.updatedAt,
                        };
                        var tempPrevio = {
                            filtros: filtros,
                            idempresa: usuarioOmisiones.uid_empresa,
                            tipoNotificacion: item.packageInfo.tipo.toLowerCase(),
                            id: item._id,
                            cantidad: item.changes.previous.cantidad,
                            disponibles: item.changes.previous.disponibles,
                            utilizadas: item.changes.previous.utilizadas,
                            costo_total: item.changes.previous.utilizadas * item.changes.previous.costo_unitario,
                            fecha: item.changes.previous.updatedAt,
                        };
                        if (temp.tipoNotificacion === 'sms' && tempSMS === null) {
                            editarSMS({
                                ...temp,
                                previo: tempPrevio
                            });
                            tempSMS = temp;
                        }
                        if (temp.tipoNotificacion === 'email' && tempEmail === null) {
                            tempEmail = temp;
                            editarEmail({
                                ...temp,
                                previo: tempPrevio
                            });
                        }
                        if (temp.tipoNotificacion === 'whatsapp' && tempWhatsapp === null) {
                            tempWhatsapp = temp;
                            editarWhatsapp({
                                ...temp,
                                previo: tempPrevio
                            });
                        }
                        if (temp.tipoNotificacion === 'voz' && tempVoz === null) {
                            tempVoz = temp;
                            editarVoz({
                                ...temp,
                                previo: tempPrevio
                            });
                        }
                    });
                }
            } catch (error) {
                console.error("Error al cargar Company History:", error);
            } finally {
                editarCargaActiva(false);
                updateComponentProgress('table', 100, false);
                setIsLoadingPackages(false);
            }
        }
        const requestPackages = async (filtros) => {
            try {
                /* CARGA DE CONSUMO PAQUETES */
                let getDataPackages = new URLSearchParams({
                    companyId: usuarioOmisiones.uid_empresa,
                }).toString()
                const responsePackages = await ConsumoService.getNotificationPackages(`?${getDataPackages}`);
                if (responsePackages && responsePackages.success) {
                    let packages = responsePackages.data;

                    var tempSMS = null;
                    var tempEmail = null;
                    var tempWhatsapp = null;
                    var tempVoz = null;

                    var tempPrevSMS = null;
                    var tempPrevEmail = null;
                    var tempPrevWhatsapp = null;
                    var tempPrevVoz = null;
                    packages.forEach((item) => {
                        var temp = {
                            filtros: filtros,
                            idempresa: usuarioOmisiones.uid_empresa,
                            tipoNotificacion: item.notificationTypeId?.nombre.toLowerCase(),
                            id: item.id,
                            cantidad: item.cantidad,
                            disponibles: item.disponibles,
                            utilizadas: item.utilizadas,
                            costo_total: item.utilizadas * item.costo_unitario,
                            fecha: item.updatedAt,
                        };
                        if (temp.tipoNotificacion === 'sms' && tempSMS === null) {
                            editarSMS(temp);
                            tempSMS = temp;
                        } else if (temp.tipoNotificacion === 'sms' && tempPrevSMS === null) {
                            editarSMS({
                                ...tempSMS,
                                previo: temp
                            });
                            tempPrevSMS = temp;
                        }
                        if (temp.tipoNotificacion === 'email' && tempEmail === null) {
                            tempEmail = temp;
                            editarEmail(temp);
                        } else if (temp.tipoNotificacion === 'email' && tempPrevEmail === null) {
                            editarEmail({
                                ...tempEmail,
                                previo: temp
                            });
                            tempPrevEmail = temp;
                        }
                        if (temp.tipoNotificacion === 'whatsapp' && tempWhatsapp === null) {
                            tempWhatsapp = temp;
                            editarWhatsapp(temp);
                        } else if (temp.tipoNotificacion === 'whatsapp' && tempPrevWhatsapp === null) {
                            editarWhatsapp({
                                ...tempWhatsapp,
                                previo: temp
                            });
                            tempPrevWhatsapp = temp;
                        }
                        if (temp.tipoNotificacion === 'voz' && tempVoz === null) {
                            tempVoz = temp;
                            editarVoz(temp);
                        } else if (temp.tipoNotificacion === 'voz' && tempPrevVoz === null) {
                            editarVoz({
                                ...tempVoz,
                                previo: temp
                            });
                            tempPrevVoz = temp;
                        }
                    });

                    if (fecha.getMonth() !== new Date().getMonth()) {
                        updateComponentProgress('table', 50, false);
                        requestCompanyHistory(filters);
                    } else {
                        editarCargaActiva(false);
                        updateComponentProgress('table', 100, false);
                    }
                }
            } catch (error) {
                editarCargaActiva(false);
                updateComponentProgress('table', 100, false);
                console.error("Error al cargar Packages:", error);
            } finally {
                setIsLoadingPackages(false);
            }
        }

        let startDate = new Date(fecha.getFullYear(), fecha.getMonth(), 1, 0, 0, 0);
        let endDate = new Date(fecha.getFullYear(), fecha.getMonth() + 1, 0, 23, 59, 59);

        const fecha_inicio = dayjs(startDate.getTime()).tz(dayjs.tz.guess()).format("YYYY-MM-DD")
        const fecha_fin = dayjs(endDate.getTime()).format("YYYY-MM-DD")
        let filters = {
            fechaInicio: fecha_inicio,
            fechaFin: fecha_fin
        }

        requestPackages(filters);
    }, [usuarioOmisiones]);

    const isSelected = (id) => {
        if (selTipoConsumo.length === 0) {
            return true;
        }
        else {
            return selTipoConsumo.some(option => option.value === id);
        }
    };

    const listaTablas = [
        !isSelected(0) ? <></> :
            <Col xl={12} xxl={selTipoConsumo.length === 1 ? 12 : 6}>
                <CardSMS />
            </Col>,
        !isSelected(1) ? <></> :
            <Col xl={12} xxl={selTipoConsumo.length === 1 ? 12 : 6}>
                <CardEmail />
            </Col>,
        !isSelected(2) ? <></> :
            <Col xl={12} xxl={selTipoConsumo.length === 1 ? 12 : 6}>
                <CardWhatsapp />
            </Col>,
        !isSelected(3) ? <></> :
            <Col xl={12} xxl={selTipoConsumo.length === 1 ? 12 : 6}>
                <CardVoz />
            </Col>,
    ];


    useEffect(() => {
        if (!window.printReportModule) {
            window.printReportModule = new PrintReportModule({
                captureQuality: 0.95,
                pdfFormat: 'A4',
                pdfOrientation: 'landscape',
                useNativeTables: true,
                maxRowsPerPage: 30,
                tableFontSize: 7,

                // ✅ CONFIGURACIÓN ESPECÍFICA PARA KILOMETRAJE
                reportType: 'tiempos',
                captureContainer: '#reporte-consumos-content',

                tableExtractionConfig: {
                    enabled: true,
                    selector: '#tabla-consumos',
                    title: 'Listado de consumos',
                    type: 'auto'
                },

                // 📊 ESTRATEGIA HORIZONTAL: Capturar por filas (recomendado para landscape)
                horizontalStrategy: 'rows',
                horizontalRows: [
                    {
                        title: 'Resumen y Gráfico de tiempos',
                        selector: '.g-3:first-of-type', // Primera fila con las dos cards
                        identifier: 'kilometraje-fila-1',
                        selectorMethod: 'direct'
                    },

                ],

                // 📱 ESTRATEGIA VERTICAL: Capturar targets individuales (para portrait)
                verticalStrategy: 'targets',
                captureTargets: [
                    {
                        title: 'Resumen de tiempos',
                        selector: '#card-tiempos',
                        type: 'card'
                    },

                ]
            });
        }

        return () => {
            if (window.printReportModule) {
                delete window.printReportModule;
            }
        };
    }, []);
    const getEmptyStateProps = useCallback(() => {
        if (!selectedTipoConsumo.length === 0) {
            return {
                component: <NoSelectionEmptyState reportType={'consumo'} />,
                show: true
            };
        }

        return {
            component: <NoDataEmptyState reportType={'consumo'} />,
            show: true
        };
    }, [selectedTipoConsumo]);


    return (
        <div>

            <div className=" m-3 ">
                <Row >
                    <Col md={10}>
                        <h4 className="mt-2">Consumos</h4>
                    </Col>
                </Row>

            </div>





            <FiltrosConsumos></FiltrosConsumos>

            <Card className="p-3 mb-3 mt-3">
                {/* Titulo principal de la pagina */}
                {/* <div className="d-flex justify-content-between align-items-center mb-1 mt-3">
                            <h4 className="mb-1">Reporte de Consumo</h4>
                        </div> 
                        
                <div className="d-flex justify-content-between align-items-center ">
                    <h6 className="mb-0">Filtro de consumo</h6>
                </div>*/}
                <hr className="text-danger" />
                <BitacoraFiltros
                    onGenerateReport={handleGenerateReport}
                    imprimir={cargaActiva ? false : selectedTipoConsumo.length === 0 ? false : true}
                />
                <Col md={12}>
                    {(cargaActiva) ? (
                        // ✅ USAR StandardProgressBar PARA LA DESCARGA PRINCIPAL
                        <StandardProgressBar
                            calculateTotalProgress={calculateTotalProgress}
                            debugMetrics={debugMetrics}
                        />
                    ) : (<></>)}
                </Col>
            </Card>
            {selectedTipoConsumo.length === 0 ? (
                <WelcomeEmptyState reportType="consumos" />
            ) : cargaActiva ? (
                <LoadingEmptyState reportType="consumos" />
            ) : !datosDisponibles ? (
                getEmptyStateProps().component
            ) : (
                <div id="reporte-consumos-content">
                    <ConsumosTotales id="card-consumos" />
                    {/* Lista del resultado del filtro */}
                    <div id="tabla-consumos">
                        <Row className='g-3 pt-3'>
                            <CardConsumos />
                        </Row>
                    </div>
                </div>
            )}



        </div>



    );
};

export default ConsumoReport;